<template>
  <section>
    <div class="title is-5 has-text-centered">
      Actividades, Horas comprometidas y Realizadas
      <hr class="dropdown-divider" aria-role="menuitem" />
    </div>

    <div class="columns">
      <div class="column has-text-right">
        <b-button
          :label="
            openedDetail.length === 0
              ? 'Expandir Observaciones'
              : 'Contraer Observaciones'
          "
          :icon-left="
            openedDetail.length === 0 ? 'plus-circle' : 'minus-circle'
          "
          type="is-blue-color"
          @click="
            openedDetail.length === 0
              ? (openedDetail = performances)
              : (openedDetail = [])
          "
        />
      </div>
    </div>

    <b-table
      striped
      :data="
        performances.filter((x) => x.alt_name_area === academicArea.alt_name)
      "
      paginated
      per-page="10"
      :pagination-simple="false"
      pagination-position="bottom"
      aria-next-label="Siguiente"
      aria-previous-label="Anterior"
      aria-page-label="Página"
      aria-current-label="Página actual"
      :opened-detailed="openedDetail"
      detailed
    >
      <b-table-column
        field="commitment_index"
        label="N°"
        width="5%"
        v-slot="props"
      >
        {{ props.index + 1 }}
      </b-table-column>
      <b-table-column
        field="alt_name_activity"
        label="Actividad Académica"
        v-slot="props"
      >
        {{ props.row.alt_name_activity }}
      </b-table-column>
      <b-table-column
        field="is_weekly_hours"
        label="Tipo de Hora"
        v-slot="props"
      >
        {{ props.row.is_weekly_hours ? "Semanales" : "Semestrales" }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_1"
        label="Horas Comprometidas 1er Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_1 }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_2"
        label="Horas Comprometidas 2do Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_2 }}
      </b-table-column>
      <b-table-column
        field="hours_completed_semester_1"
        label="Horas Realizadas 1er Semestre"
        v-slot="props"
      >
        {{ props.row.hours_completed_semester_1 }}
      </b-table-column>
      <b-table-column
        field="hours_completed_semester_2"
        label="Horas Realizadas 2do Semestre"
        v-slot="props"
      >
        {{ props.row.hours_completed_semester_2 }}
      </b-table-column>
      <b-table-column
        v-if="
          academicArea.alt_name === 'Docencia' ||
          academicArea.alt_name === 'Educación Continua'
        "
        field="subject_name"
        label="Asignatura"
        v-slot="props"
      >
        {{
          (function () {
            if (props.row.subject_code == null || props.row.subject_code === "")
              return "";
            const filtered = subjects.filter(
              (subject) => parseInt(props.row.subject_code) === subject.codigo
            );
            return filtered.length > 0 ? filtered[0].codigo_nombre : "";
          })()
        }}
      </b-table-column>
      <b-table-column label="Acciones" v-slot="props">
        <b-button
          icon-left="upload"
          type="is-info"
          @click="openModalAddHours(props.row.id)"
        />
      </b-table-column>
      <template #detail="props">
        <div class="content">
          <div class="box">
            <p>
              <b>Observaciones:</b>
              {{ props.row.observations }}
            </p>
          </div>

          <div class="mt-5">
            <h5 class="title is-5 has-text-centered mb-3">Evidencias</h5>

            <div class="table-container box">
              <b-table
                :data="props.row.evidences || []"
                :bordered="false"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                :mobile-cards="true"
                class="is-fullwidth"
              >
                <b-table-column
                  field="file_type"
                  label="Tipo"
                  width="50"
                  v-slot="{ row }"
                >
                  <b-icon
                    :icon="getFileIcon(row.alt_name)"
                    :type="getFileIconColor(row.alt_name)"
                  />
                </b-table-column>

                <b-table-column
                  field="alt_name"
                  label="Nombre del archivo"
                  v-slot="{ row }"
                >
                  {{ row.alt_name }}
                </b-table-column>

                <b-table-column
                  field="created_at"
                  label="Fecha de creación"
                  v-slot="{ row }"
                >
                  {{ formatDate(row.created_at) }}
                </b-table-column>

                <b-table-column
                  field="actions"
                  label="Acciones"
                  width="140"
                  v-slot="{ row }"
                >
                  <div v-if="row.id != -1" class="buttons is-centered">
                    <b-button
                      type="is-info"
                      icon-left="eye"
                      size="is-small"
                      @click="verEvidence(row)"
                    />
                    <b-button
                      type="is-warning"
                      icon-left="edit"
                      size="is-small"
                      @click="editarEvidence(row)"
                    />
                    <b-button
                      type="is-danger"
                      icon-left="trash-alt"
                      size="is-small"
                      @click="eliminarEvidence(row)"
                    />
                  </div>
                  <div v-else class="buttons is-centered">
                    <b-button
                      type="is-info"
                      icon-left="eye"
                      size="is-small"
                      @click="openModalSaiHours(row)"
                    />
                  </div>
                </b-table-column>

                <template #empty>
                  <div class="has-text-centered p-4">
                    <b-icon
                      icon="folder-open"
                      size="is-large"
                      class="mb-2"
                    ></b-icon>
                    <p>No hay evidencias disponibles</p>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </template>

      <template slot="empty" slot-scope="props">
        <div class="columns is-centered">
          <div class="column is-6 is-centered has-text-centered">
            <b-message type="is-warning">
              Aún no ha agregado Actividades para
              {{ academicArea.alt_name }}, a medida que agregue se irán
              mostrando en esta tabla.
            </b-message>
          </div>
        </div>
      </template>
    </b-table>
    <b-loading is-full-page v-model="isLoading" />
    <b-modal
      v-model="isModalAddHours"
      :width="1000"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
      :can-cancel="false"
    >
      <template #default="props">
        <modalAddHours
          :activity-id="activityId"
          :subjects="subjects"
          :subjectsSemester1="subjectsSemester1"
          :subjectsSemester2="subjectsSemester2"
          @close="props.close"
          @refresh="$emit('refresh')"
        />
      </template>
    </b-modal>
    <!-- Modal para previsualización de archivos -->
    <b-modal
      :active.sync="isPreviewModalActive"
      :width="1200"
      :can-cancel="['escape', 'outside']"
      scroll="keep"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            {{ selectedEvidence ? selectedEvidence.alt_name : "" }}
          </p>
        </header>
        <div class="card-content">
          <div v-if="selectedEvidence" class="content has-text-centered">
            <!-- Previsualización basada en el tipo de archivo -->
            <div
              v-if="isImageFile(selectedEvidence.alt_name)"
              class="image-preview"
            >
              <img :src="getFileUrl(selectedEvidence)" class="preview-image" />
            </div>

            <div
              v-else-if="isPdfFile(selectedEvidence.alt_name)"
              class="pdf-preview"
            >
              <!-- Usando vue-pdf o incrustando el PDF -->
              <iframe
                :src="getFileUrl(selectedEvidence)"
                class="pdf-frame"
                width="100%"
                height="500"
              ></iframe>
            </div>

            <div v-else class="file-info">
              <b-icon
                :icon="getFileIcon(selectedEvidence.alt_name)"
                :type="getFileIconColor(selectedEvidence.alt_name)"
                size="is-large"
              >
              </b-icon>
              <p class="mt-3">
                Este tipo de archivo no se puede previsualizar.
                <br />
                <b-button
                  class="mt-2"
                  type="is-primary"
                  icon-left="download"
                  @click="downloadFile(selectedEvidence)"
                >
                  Descargar
                </b-button>
              </p>
            </div>
          </div>
        </div>
        <footer class="modal-card-foot">
          <div class="actions has-text-right">
            <button
              class="button"
              type="button"
              @click="isPreviewModalActive = false"
            >
              Cerrar
            </button>
            <button
              class="button is-primary"
              type="button"
              @click="downloadFile(selectedEvidence)"
            >
              Descargar
            </button>
          </div>
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active.sync="isReplaceModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Reemplazar Archivo</p>
          <button
            class="delete"
            type="button"
            @click="isReplaceModalActive = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <p>
              Estás a punto de reemplazar el archivo:
              <strong>{{ fileToReplace ? fileToReplace.alt_name : "" }}</strong>
            </p>

            <b-field label="Selecciona un nuevo archivo">
              <b-upload
                v-model="fileUpload"
                :disabled="isUploading"
                drag-drop
                expanded
                type="is-primary"
                accept=".docx,.pdf,.doc,.xlsx,.png,.jpeg"
              >
                <div class="has-text-centered">
                  <b-icon icon="upload" size="is-large"> </b-icon>
                  <p>Arrastra tu archivo aquí o haz clic para seleccionarlo</p>
                </div>
              </b-upload>
            </b-field>
            <div class="tags" v-if="fileUpload">
              <span class="tag is-primary">
                {{ fileUpload.name }}
                <button
                  class="delete is-small"
                  type="button"
                  @click="fileUpload = null"
                ></button>
              </span>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="isReplaceModalActive = false"
          >
            Cancelar
          </button>
          <button
            class="button is-primary"
            :disabled="!fileUpload || isUploading"
            :class="{ 'is-loading': isUploading }"
            type="button"
            @click="confirmReplaceFile"
          >
            Reemplazar
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal
      :active.sync="isActiveModalSaiHours"
      :width="800"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
      aria-label="Modal para completar horas con SAI"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Horas Realizadas</p>
        </header>
        <div class="card-content">
          <b-table
            paginated
            per-page="10"
            :pagination-simple="false"
            pagination-position="bottom"
            aria-next-label="Siguiente"
            aria-previous-label="Anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
            :data="filteredSubjectsModal"
          >
            <b-table-column field="codigo" label="Código" v-slot="props">
              {{ props.row.codigo }}
            </b-table-column>
            <b-table-column
              field="asignatura"
              label="Asignatura"
              v-slot="props"
            >
              {{ props.row.asignatura }}
            </b-table-column>

            <b-table-column field="semestre" label="Semestre" v-slot="props">
              {{ props.row.semestre }}
            </b-table-column>
            <b-table-column field="horario" label="Horario" v-slot="props">
              {{ props.row.horario }}
            </b-table-column>
            <b-table-column field="tel" label="TEL" v-slot="props">
              {{ props.row.tel }}
            </b-table-column>
            <b-table-column
              field="total_hours"
              label="Horas Totales"
              v-slot="props"
            >
              {{ props.row.total_hours }}
            </b-table-column>
          </b-table>
        </div>
        <footer class="modal-card-foot">
          <div class="actions has-text-right">
            <button
              class="button is-primary"
              type="button"
              @click="closeModalSaiHours"
            >
              Aceptar
            </button>
          </div>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import axios from "axios";
import ConfirmDeleteCommitment from "./ConfirmDeleteCommitment.vue";
import modalAddHours from "./modalAddHours.vue";
import { filter } from "lodash";

export default {
  props: {
    academicArea: {
      type: Object,
      required: true,
    },
    performances: {
      type: Array,
      required: true,
    },
    subjects: {
      type: Array,
    },
    subjectsSemester1: {
      type: Array,
      required: true,
    },
    subjectsSemester2: {
      type: Array,
      required: true,
    },
  },

  components: {
    ConfirmDeleteCommitment,
    modalAddHours,
  },

  data() {
    return {
      isLoading: false,
      isModalConfirmDeleteCommitment: false,
      commitmentToDelete: null,
      openedDetail: [],
      isEditing: false,

      //Datos a guardar
      selected_academic_activity: null,
      isWeekly: true,
      hours_committed_semester_1: null,
      hours_committed_semester_2: null,
      hours_completed_semester_1: null,
      hours_completed_semester_2: null,
      observations: null,
      commitmentId: null,
      commitment_index: null,
      disabled_docencia_comp: false,
      selected_subject: null,
      isModalAddHours: false,
      need_subject: false,
      disable_subject: true,
      is_edit: false,
      activityId: null,
      isPreviewModalActive: false,
      selectedEvidence: null,
      isReplaceModalActive: false,
      fileToReplace: null,
      fileUpload: null,
      isUploading: false,
      isActiveModalSaiHours: false,
      filteredSubjectsModal: [],
      totalHoursSemester1: 0,
      totalHoursSemester2: 0,
    };
  },

  created() {},

  methods: {
    async addCommitment() {
      this.isLoading = true;
      let commitment = {
        hours_committed_semester_1: this.hours_committed_semester_1,
        hours_committed_semester_2: this.hours_committed_semester_2,
        is_weekly_hours: this.isWeekly,
        academic_area_id: this.academicArea.id,
        alt_name_area: this.academicArea.alt_name,
        alt_name_activity: this.selected_academic_activity.alt_name,
        academic_activity_id: this.selected_academic_activity.id,
        observations: this.observations,
        commitment_index: this.commitment_index
          ? this.commitment_index
          : this.performances.length + 1,
        subject_code: this.selected_subject
          ? this.selected_subject.codigo
          : null,
      };

      await axios
        .post("/performances/add-commitment.json", commitment)
        .then((response) => {
          if (response.data.warning) {
            this.$buefy.dialog.alert({
              title: "Advertencia",
              message: response.data.message,
              type: "is-warning",
              hasIcon: true,
              confirmText: "OK",
            });
          } else {
            commitment.id = response.data.id;
            this.$emit("addCommitment", commitment);

            this.hours_committed_semester_1 = null;
            this.hours_committed_semester_2 = null;
            this.isWeekly = true;
            this.selected_academic_activity = null;
            this.observations = null;
            this.commitment_index = null;
            this.$buefy.toast.open({
              message: "Se ha Agregado la Actividad al Compromiso",
              type: "is-success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          const errorMsg = error.response.data.errors
            ? error.response.data.errors
            : "Ha ocurrido un error al intentar guardar el compromiso.";
          this.$buefy.dialog.alert({
            title: "Error",
            message: errorMsg,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    openModalAddHours(activityId) {
      this.activityId = activityId;
      this.isModalAddHours = true;
    },

    getFileIcon(filename) {
      if (!filename) return "file";

      const extension = filename.split(".").pop().toLowerCase();

      if (["doc", "docx"].includes(extension)) return "file-word";
      if (["xls", "xlsx"].includes(extension)) return "file-excel";
      if (extension === "pdf") return "file-pdf";
      if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension))
        return "file-image";

      return "globe";
    },

    getFileIconColor(filename) {
      if (!filename) return "";

      const extension = filename.split(".").pop().toLowerCase();

      if (["doc", "docx"].includes(extension)) return "is-info";
      if (["xls", "xlsx"].includes(extension)) return "is-success";
      if (extension === "pdf") return "is-danger";
      if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension))
        return "is-warning";

      return "";
    },

    formatDate(dateStr) {
      if (!dateStr) return "";

      // Si el valor es "No Aplica" o similar, devolverlo tal como está
      if (
        typeof dateStr === "string" &&
        (dateStr.toLowerCase().includes("no aplica") ||
          dateStr.toLowerCase().includes("n/a"))
      ) {
        return dateStr;
      }

      const date = new Date(dateStr);

      // Verificar si la fecha es válida
      if (isNaN(date.getTime())) {
        return dateStr; // Si no es una fecha válida, devolver el valor original
      }

      // Formato chileno: DD-MM-YYYY HH:MM
      return new Intl.DateTimeFormat("es-CL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).format(date);
    },

    verEvidence(evidence) {
      this.selectedEvidence = evidence;
      this.isPreviewModalActive = true;
    },

    editarEvidence(evidence) {
      this.fileToReplace = evidence;
      this.fileUpload = null;
      this.isReplaceModalActive = true;
    },

    confirmReplaceFile() {
      if (!this.fileUpload || !this.fileToReplace) return;

      this.isUploading = true;
      this.replace_file(this.fileToReplace, this.fileUpload);
      this.isReplaceModalActive = false;
      this.isUploading = false;
      this.fileUpload = null;
      this.fileToReplace = null;
    },

    eliminarEvidence(evidence) {
      this.$buefy.dialog.confirm({
        title: "Eliminar evidencia",
        message: `¿Está seguro de eliminar la evidencia "${evidence.alt_name}"?`,
        confirmText: "Eliminar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.deleteEvidence(evidence);
        },
      });
    },

    deleteEvidence(evidence) {
      this.isLoading = true;
      axios
        .delete(`/evidences/${evidence.id}.json`)
        .then((response) => {
          this.$emit("refreshPerformance");
          this.isLoading = false;
          this.$buefy.toast.open({
            message: "Se ha eliminado la evidencia",
            type: "is-success",
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          const errorMsg = error.response.data.errors
            ? error.response.data.errors
            : "Ha ocurrido un error al intentar eliminar la evidencia.";
          this.$buefy.dialog.alert({
            title: "Error",
            message: errorMsg,
            type: "is-danger",
            hasIcon: true,
          });
        });
    },

    isImageFile(filename) {
      if (!filename) return false;
      const extension = filename.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(extension);
    },

    isPdfFile(filename) {
      if (!filename) return false;
      return filename.toLowerCase().endsWith(".pdf");
    },

    getFileUrl(evidence) {
      if (evidence.url) {
        return evidence.url;
      }
    },

    downloadFile(evidence) {
      if (!evidence) return;
      if (evidence.url) {
        window.open(evidence.url, "_blank");
      }
    },
    replace_file(evidence, file) {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("file", file);
      axios
        .post("/evidences/" + evidence.id + "/replace_file.json", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$emit("refreshPerformance");
          this.isLoading = false;
          this.$buefy.toast.open({
            message: "Se ha actualizado la evidencia",
            type: "is-success",
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          const errorMsg = error.response.data.errors
            ? error.response.data.errors
            : "Ha ocurrido un error al intentar actualizar la evidencia.";
          this.$buefy.dialog.alert({
            title: "Error",
            message: errorMsg,
            type: "is-danger",
            hasIcon: true,
          });
        });
    },
    openModalSaiHours(performanceActivity) {
      const filteredSubjectsSemester1 = this.subjectsSemester1.filter(
        (subject) =>
          subject.codigo === parseInt(performanceActivity.subject_code)
      );
      const filteredSubjectsSemester2 = this.subjectsSemester2.filter(
        (subject) =>
          subject.codigo === parseInt(performanceActivity.subject_code)
      );

      if (
        filteredSubjectsSemester1.length === 0 &&
        filteredSubjectsSemester2.length === 0
      ) {
        this.$buefy.dialog.alert({
          title: "Error",
          message:
            "No registra horas realizadas de esta asignatura en SAI. Ingrese las horas manualmente.",
          type: "is-danger",
          hasIcon: true,
          iconPack: "fa",
          icon: "times-circle",
          confirmText: "Ok",
          onConfirm: () => (this.isActiveModalSaiHours = false),
        });
        return;
      }

      let horasSemestre1 = 0;
      let horasSemestre2 = 0;
      filteredSubjectsSemester1.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre1 += hour_t + hour_e + hour_l;
        this.filteredSubjectsModal.push({
          ...subject,
          total_hours: hour_t + hour_e + hour_l,
          semestre: "1er Semestre",
        });
      });
      filteredSubjectsSemester2.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre2 += hour_t + hour_e + hour_l;
        this.filteredSubjectsModal.push({
          ...subject,
          total_hours: hour_t + hour_e + hour_l,
          semestre: "2do Semestre",
        });
      });
      this.totalHoursSemester1 = horasSemestre1;
      this.totalHoursSemester2 = horasSemestre2;

      this.isActiveModalSaiHours = true;
    },
    closeModalSaiHours() {
      this.isActiveModalSaiHours = false;
      this.filteredSubjectsModal = [];
      this.totalHoursSemester1 = 0;
      this.totalHoursSemester2 = 0;
    },
  },
  watch: {
    selected_subject(newValue) {
      // Ejecuta la lógica cada vez que cambie `selected_subject`
      this.disabled_docencia_comp = !(newValue != null && newValue !== "");
      if (this.disabled_docencia_comp) {
        if (!this.need_subject) {
          this.disabled_docencia_comp = false;
        }
        this.hours_committed_semester_1 = null;
        this.hours_committed_semester_2 = null;
        this.isWeekly = true;
        this.observations = null;
      }
    },
    selected_academic_activity(newValue) {
      this.disable_subject = !newValue;
      if (newValue != null && newValue !== "") {
        this.need_subject = !!newValue.requires_subject;
      } else {
        this.need_subject = false;
      }

      if (this.need_subject) {
        if (!this.is_edit) {
          this.disabled_docencia_comp = true;
          this.selected_subject = null;
          this.hours_committed_semester_1 = null;
          this.hours_committed_semester_2 = null;
          this.isWeekly = true;
          this.observations = null;
        } else {
          this.is_edit = false;
        }
      } else {
        if (!this.is_edit) {
          this.disabled_docencia_comp = false;
          this.selected_subject = null;
          this.hours_committed_semester_1 = null;
          this.hours_committed_semester_2 = null;
          this.isWeekly = true;
        } else {
          this.is_edit = false;
        }
      }
    },
    isModalAddHours: function () {
      if (!this.isModalAddHours) {
        this.$emit("refreshPerformance");
      }
    },
  },
  computed: {
    filteredSubjects() {
      // Retorna los primeros 5 elementos de la lista de opciones (subjects)
      return this.subjects.slice(0, 5);
    },
  },
};
</script>

<style scoped>
.inline-label-tooltip {
  display: flex;
  align-items: center;
}

.inline-label-tooltip .label-container {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem; /* Espaciado entre el label y el b-input */
}

.inline-label-tooltip .label-container .control {
  margin-left: 0.5rem; /* Espaciado entre el label y el tooltip */
}
</style>
